import { render, staticRenderFns } from "./DS.vue?vue&type=template&id=4826d4f6&scoped=true&"
import script from "./DS.vue?vue&type=script&lang=js&"
export * from "./DS.vue?vue&type=script&lang=js&"
import style0 from "./DS.vue?vue&type=style&index=0&id=4826d4f6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826d4f6",
  null
  
)

export default component.exports